import React, {
    useContext, 
    useMemo
} from 'react';
import {
    Box, useTheme 
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
    FormContext 
} from '../../../contexts/form';

type Props = {
    currentPosition: number,
    sectionKey: string,
    color?: string,
    length?: number
};

const useStyles = makeStyles(() => ({
    progress: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        columnGap: '8px',
        marginTop: '16px'
    },
    circle: {
        width: '8px',
        height: '8px',
        borderRadius: '50%'
    }
}));

export default function ProgressBar({
    currentPosition,
    sectionKey,
    color,
    length
}: Props): JSX.Element {
    const formContext = useContext(FormContext);
    const theme = useTheme();
    const classes = useStyles();

    const currentSectionIndex = useMemo(() => {
        return formContext?.sections.findIndex(s => s.key === sectionKey);
    }, [formContext?.sections, sectionKey]);
    const pastSections = useMemo(() => {
        return formContext?.sections.slice(0, currentSectionIndex);
    }, [formContext?.sections, currentPosition]);

    const sectionOffset = useMemo(() => {
        return pastSections.reduce((acc, s) => {
            if (s.key === sectionKey) return acc;
            return acc + s.length;
        }, 0) || 0;
    }, [pastSections]);

    return (
        <Box className={classes.progress}>
            {Array.from({
                length: length || formContext?.sections[currentSectionIndex]?.length 
            }).map((_, index) => (
                <Box
                    key={index}
                    className={classes.circle}
                    style={{
                        backgroundColor: (currentPosition - sectionOffset) >= index ? (color || formContext?.sections[currentSectionIndex]?.colors?.main) : theme.palette.transparent,
                        border: `1px solid ${color || formContext?.sections[currentSectionIndex]?.colors?.main}`
                    }}
                />
            ))}
        </Box>
    );
}
